<template>
	<div class="callback">
		<socket size="112px"></socket>
	</div>
</template>

<script>
import { AuthRedirectType, Source } from "@teaming/common-enums";

export default {
	name: "Callback",

	props: {
		// eslint-disable-next-line vue/no-unused-properties
		action: {
			type: String,
			default: AuthRedirectType.NOOP,
			validator( type ) {
				return AuthRedirectType.includes( type );
			},
		},
	},

	methods: {
		/* eslint-disable vue/no-unused-properties */
		handleLoginEvent( data ) {
			const target = data.appState?.target;
			if ( !data.error ) {
				const loadingRoutes = [ "/", "/loading", ];
				if ( loadingRoutes.includes( target ) || !target ) {
					this.$router.push( "/loading" );
				} else if ( /^\/t2\/.*/.test( target ) ) {
					const localTarget = target.slice( 3 ); // eslint-disable-line no-magic-numbers
					this.$router.push( localTarget );
				} else {
					window.location.assign( target );
				}
			}
		},
		handleLoginError( { error, } ) {
			const UNAUTHORIZED = 401;
			const text = this.$t(
				error.response?.status === UNAUTHORIZED ?
					"slice-apple.components.Callback.invalidAccount" :
					"slice-apple.components.Callback.unknownError"
			);
			this.$notify( { type: "error", text, } );
			this.$router.push( "/signup" );
		},
		/* eslint-enable vue/no-unused-properties */
	},

	async created() {
		// if these params are present, we are in the email post-verification
		// flow and need to log the user back in
		const { code, success, postverify, } = this.$route.query;
		if ( postverify && code === "success" && success === "true" ) {
			await this.$auth.logout( { localOnly: true, } );
			return this.$auth.login( Source.EMAIL, { target: "/", } );
		}

		// otherwise we are handling authentication normally
		await this.$auth.handleAuthentication( { authRedirectType: this.action, } );
	},
};
</script>

<style lang="scss" scoped>
.callback {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
